import { createSelector } from '@reduxjs/toolkit';

import type { IUsersState } from './types';
import type { RootState } from '@/redux/store';

export const usersStateSelector = (state: RootState) => state.users;

export const selectedUserForModalSelector = createSelector(
  usersStateSelector,
  (state: IUsersState) => state.selectedUserForModal,
);

export const isDeleteUserModalOpenSelector = createSelector(
  usersStateSelector,
  (state: IUsersState) => state.isDeleteUserModalOpen,
);
